import { DhlIconWrapper as NewIconWrapper } from "@dhl-official/react-library";
import React from "react";
import PropTypes from "prop-types";

/**
 * Migration wrapper for IconWrapper component
 * This component helps transition from old UI library to new UI library
 * by handling prop mapping and maintaining backward compatibility
 */
export const IconWrapper = (props) => {
  const { size, children, ...rest } = props;

  const newProps = {
    ...rest,
    size: size || "regular",
  };

  return <NewIconWrapper {...newProps}>{children}</NewIconWrapper>;
};

IconWrapper.propTypes = {
  size: PropTypes.string,
  children: PropTypes.node,
};
